document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector(
    "body.template-product form .product-description .product-description-toggle"
  );

  if (toggle) {
    toggle.addEventListener("click", function () {
      this.classList.toggle("active");
    });
  }
});

async function initFlickityOnMobile() {
  const shouldInit = window.innerWidth <= 980;
  if(shouldInit){
    const loader = new WAU.Helpers.scriptLoader();
     await loader.load([jsAssets.flickity])    
  }
  // Select all product image wrappers
  const sliders = document.querySelectorAll(
    "#product-nomaka .product-images-wrapper"
  );  
  sliders.forEach((slider) => {
    // If already has Flickity, destroy it before re-init
    if (slider.classList.contains("flickity-enabled")) {
      const flkty = Flickity.data(slider);
      if (flkty) {
        flkty.destroy();
      }
    }
    if (shouldInit) {
      // Add Flickity cell class to children
      slider.querySelectorAll("img, video").forEach((el) => {
        el.classList.add("carousel-cell");
      });

      // Wait until all images are loaded before initializing
      imagesLoaded(slider, () => {
        new Flickity(slider, {
          cellSelector: ".carousel-cell",
          wrapAround: true,
          pageDots: true,
          prevNextButtons: true,
          imagesLoaded: true,
        });
      });
    }
  });
}

// Run on load and resize
window.addEventListener("load", initFlickityOnMobile);

// Hook into Shopify’s variant change (or your custom handler)
window.onVariantChange = function () {
  window.initProductLightbox?.();

  // Give Shopify time to swap images, then re-init Flickity
  setTimeout(() => {
    initFlickityOnMobile();
  }, 150);
};



// document
//   .querySelectorAll('.swatch-element input[type="radio"]')
//   .forEach((input) => {
//     input.addEventListener("change", () => {
//       const variantId = input.id; // your variant ID
//       const productHandle = input.closest("[data-product-handle]").dataset
//         .productHandle;

//       window.location.href = `/products/${productHandle}?variant=${variantId}`;
//     });
//   });

function initFlickityFeaturesOnMobile() {
  const shouldInit = window.innerWidth <= 980;

  const sliders = document.querySelectorAll(
    ".custom-liquid .grid__wrapper div:has(.details-features-gallery) .details-features-gallery"
  );

  sliders.forEach((slider) => {
    if (shouldInit && !slider.classList.contains("flickity-enabled")) {
      // Add Flickity class to children (optional)
      slider.querySelectorAll(".feature-item").forEach((item) => {
        item.classList.add("carousel-cell");
      });

      new Flickity(slider, {
        cellSelector: ".carousel-cell",
        wrapAround: true,
        pageDots: true,
        prevNextButtons: true,
        imagesLoaded: true,
        cellAlign: "left",
        imagesLoaded: true,
      });
    }
  });
}

window.addEventListener("load", initFlickityFeaturesOnMobile);
window.addEventListener("resize", initFlickityFeaturesOnMobile);

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("size-guide-modal");
  const openBtn = document.querySelector(".size-guide-link");
  const closeBtn = document.querySelector(".size-guide-modal .close-modal");

  openBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    modal.classList.add("active");
  });

  closeBtn?.addEventListener("click", function () {
    modal.classList.remove("active");
  });

  // Optional: close modal when clicking outside the content
  modal?.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.classList.remove("active");
    }
  });
});

(function () {
  const selectorsToHide = [
    "#shopify-section-template--25498439418240__section_heading_jkb3wx",
    "#shopify-section-template--25498253132160__section_heading_jkb3wx",
    "#shopify-section-template--25498439418240__custom_liquid_ac9gGJ",
    "#shopify-section-template--25498253132160__custom_liquid_ac9gGJ",
  ];

  function hideIfNoFeatures() {
    const gallery = document.querySelector(".template-product");
    if (!gallery) return;

    if (!gallery.querySelector(".feature-item")) {
      selectorsToHide.forEach((sel) => {
        const el = document.querySelector(sel);
        if (el) {
          el.style.display = "none";
        }
      });
    }
  }

  // Observe DOM changes so it works when Shopify loads content dynamically
  const observer = new MutationObserver(() => {
    hideIfNoFeatures();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also run immediately in case elements are already there
  hideIfNoFeatures();
})();

document.addEventListener("DOMContentLoaded", function () {
  // Get current URL path
  var path = window.location.pathname;

  // Select all linklist items
  var links = document.querySelectorAll(
    ".simple-linklist-section .linklist-section__link"
  );

  // Remove any previous active class
  links.forEach(function (link) {
    link.classList.remove("active");
  });

  // Check if we're on /collections/ or a specific collection
  if (path === "/collections/" || path === "/collections") {
    // Make "ALL" active
    links.forEach(function (link) {
      if (link.textContent.trim().toUpperCase() === "ALL") {
        link.classList.add("active");
      }
    });
  } else if (path.startsWith("/collections/")) {
    // Extract category from URL
    var categoryFromUrl = path.split("/")[2].toLowerCase();

    links.forEach(function (link) {
      var linkText = link.textContent.trim().toLowerCase();
      if (linkText === categoryFromUrl) {
        link.classList.add("active");
      }
    });
  }
});

// Dot navigation for images
let imageObserver;
let mutationObserver;

function initImageDots(activeIndex = 0) {
  const wrapper = document.querySelector(".product-images-wrapper");
  if (!wrapper) return;

  const productSlides = Array.from(
    wrapper.querySelectorAll(".product-image-slide, a[href]")
  );
  if (!productSlides.length) return;

  const dotsContainer = document.querySelector(
    ".product-images-anchor-container"
  );
  if (!dotsContainer) return;
  dotsContainer.innerHTML = "";

  // Build dots
  productSlides.forEach((slideEl, i) => {
    const dot = document.createElement("div");
    dot.className = "image-dot";
    dot.dataset.index = i;

    const anchor = slideEl.matches("a[href]")
      ? slideEl
      : slideEl.querySelector("a[href]");
    const href = anchor?.getAttribute("href") || "";

    // detect video
    const isSelfHostedVideo =
      /\.(mp4|webm|ogg)(\?.*)?$/i.test(href) ||
      !!slideEl.querySelector('video, source[type^="video/"]') ||
      anchor?.dataset.type === "video" ||
      anchor?.getAttribute("data-type") === "video";

    dotsContainer.appendChild(dot);
  });

  const imageDots = Array.from(dotsContainer.querySelectorAll(".image-dot"));

  function setActiveDot(index) {
    imageDots.forEach((d) => d.classList.remove("active"));
    if (imageDots[index]) imageDots[index].classList.add("active");

    lazyLoadVideos(index);
  }

  // Click scroll
  imageDots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      const target = productSlides[i];
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start", // vertical list
        });
      }
      setActiveDot(i);
    });
  });


  // Reset IntersectionObserver
  if (imageObserver) imageObserver.disconnect();
  imageObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = productSlides.indexOf(entry.target);
          if (index >= 0) setActiveDot(index);
        }
      });
    },
    {
      root: null, // viewport
      threshold: 0.5, // half visible
    }
  );

  productSlides.forEach((el) => imageObserver.observe(el));

  if (mutationObserver) mutationObserver.disconnect();
  mutationObserver = new MutationObserver(() => {
    // if slides change, re-init dots
    initImageDots(activeIndex);
  });
  mutationObserver.observe(wrapper, { childList: true, subtree: true });
}



// Wait until images exist in DOM
function waitForImages(callback) {
  const wrapper = document.querySelector(".product-images-wrapper");
  if (!wrapper) return;

  const imagesReady = () => {
    const imgs = wrapper.querySelectorAll(".hero-product-image");
    if (imgs.length) {
      callback(Array.from(imgs));
      return true;
    }
    return false;
  };

  if (!imagesReady()) {
    const observer = new MutationObserver(() => {
      if (imagesReady()) {
        observer.disconnect();
        callback(Array.from(wrapper.querySelectorAll(".hero-product-image")));
      }
    });
    observer.observe(wrapper, { childList: true, subtree: true });
  }
}

// Call on page load
document.addEventListener("DOMContentLoaded", () => {
  waitForImages(() => initImageDots(0));
});


// Call whenever variant changes and images are replaced
function onVariantChange() {
  waitForImages(() => initImageDots(0));
}
// zoom-controls.js

const zoomStep = 0.2;

// Zoom current slide image (scale + translate)
function zoomCurrent(delta) {
  const slide = document.querySelector(".gslide.current");
  if (!slide) return;

  let wrapper = slide.querySelector(".zoom-wrapper");
  let img = slide.querySelector(".gslide-media img");
  if (!img) return;

  // Wrap image only once
  if (!wrapper) {
    wrapper = document.createElement("div");
    wrapper.className = "zoom-wrapper";
    wrapper.style.overflow = "hidden";
    wrapper.style.cursor = "grab";
    wrapper.style.display = "inline-block";
    wrapper.style.position = "relative";

    img.parentNode.insertBefore(wrapper, img);
    wrapper.appendChild(img);

    // Init dataset for pan
    wrapper.dataset.offsetX = 0;
    wrapper.dataset.offsetY = 0;
    wrapper.dataset.zoom = 1;

    enableDragging(wrapper);
  }

  // Update zoom factor per wrapper
  let zoomFactor = parseFloat(wrapper.dataset.zoom || "1");
  zoomFactor = Math.max(1, zoomFactor + delta);
  wrapper.dataset.zoom = zoomFactor;

  applyTransform(wrapper);
}

function applyTransform(wrapper) {
  let zoom = parseFloat(wrapper.dataset.zoom || "1");
  let x = parseFloat(wrapper.dataset.offsetX || "0");
  let y = parseFloat(wrapper.dataset.offsetY || "0");
  const img = wrapper.querySelector("img");

  if (zoom <= 1) {
    zoom = 1; // clamp
    x = 0;
    y = 0;
    wrapper.dataset.offsetX = 0;
    wrapper.dataset.offsetY = 0;
  }

  img.style.transform = `translate(${x}px, ${y}px) scale(${zoom})`;
  img.style.transformOrigin = "center center";
  img.style.transition = "transform 0.1s ease";
}

// Enable dragging on a wrapper
function enableDragging(wrapper) {
  const img = wrapper.querySelector("img");
  let isDragging = false;
  let startX, startY;

  img.addEventListener("mousedown", (e) => {
    if (parseFloat(wrapper.dataset.zoom || "1") <= 1) return; // no drag if zoom=1
    isDragging = true;
    startX = e.clientX - parseFloat(wrapper.dataset.offsetX || "0");
    startY = e.clientY - parseFloat(wrapper.dataset.offsetY || "0");
    wrapper.style.cursor = "grabbing";
    e.preventDefault();
  });

  document.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    wrapper.dataset.offsetX = e.clientX - startX;
    wrapper.dataset.offsetY = e.clientY - startY;
    applyTransform(wrapper);
  });

  document.addEventListener("mouseup", () => {
    isDragging = false;
    wrapper.style.cursor = "grab";
  });
}

// Add button click listeners
function attachZoomButtons() {
  const btnIn = document.querySelector(".zoom-in");
  const btnOut = document.querySelector(".zoom-out");

  if (btnIn) {
    btnIn.addEventListener("click", () => zoomCurrent(zoomStep));
  } else {
    console.log("attachZoomButtons: Zoom In button not found");
  }

  if (btnOut) {
    btnOut.addEventListener("click", () => zoomCurrent(-zoomStep));
  } else {
    console.log("attachZoomButtons: Zoom Out button not found");
  }
}

// Create zoom buttons inside the overlay
function addZoomButtons() {
  const overlay = document.querySelector(".glightbox-container");
  if (!overlay) return;

  let existing = overlay.querySelector(".custom-zoom-controls");
  if (existing) existing.remove();

  const container = document.createElement("div");
  container.className = "custom-zoom-controls";

  const btnIn = document.createElement("button");
  btnIn.textContent = "+";
  btnIn.className = "zoom-in";

  const btnOut = document.createElement("button");
  btnOut.textContent = "-";
  btnOut.className = "zoom-out";

  container.appendChild(btnIn);
  container.appendChild(btnOut);
  overlay.appendChild(container);
}

document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".product-video video");

  videos.forEach((video) => {
    video.muted = true;
    video.playsInline = true;

    const productVideosObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch((err) => console.log("Autoplay blocked:", err));
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 } // play when 25% visible
    );

    productVideosObserver.observe(video);
  });

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) videos.forEach((v) => v.pause());
  });
});

// Run it once DOM is ready
document.addEventListener("DOMContentLoaded", removeColonsFromLabels);
document.addEventListener("DOMContentLoaded", () => {
  if(!window?.GLightbox)return
  GLightbox({
    selector: ".product-images-wrapper .carousel-cell", // 👈 your custom selector
    touchNavigation: true,
    autoplayVideos: false,
  });
});

function removeColonsFromLabels() {
  document
    .querySelectorAll(
      ".product__section--details .product-template__details-table li.detail p.label"
    )
    .forEach((label) => {
      label.textContent = label.textContent.replace(/:$/, "");
    });
}